import { GridColDef } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import VemigoGrid from 'src/components/VemigoGrid';
import SearchAppBar from 'src/components/VemigoSearchBar/SearchBar';
import { renderStatusCell } from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import { searchRows } from 'src/components/VemigoSearchBar/searchFunction';
import { SalesPartnerBankAccountsModel } from 'src/models/salesPartner/SalesPartnerBankAccountModel';
import { useCustomerData } from 'src/content/pages/customer/customerData';
import { useSalesPartnerData } from '../../SalesPartnerData';
import SalesPartnerBankAccountOptions from './SalesPartnerBankAccountOptions';
import AddSalesPartnerBankAccount from './AddSalesPartnerBankAccount';

const SalesPartnerBankAccountsList = () => {
  const { bankAccountTypes } = useCustomerData();
  const { bankAccountsList } = useSalesPartnerData();
  const [filteredRows, setFilteredRows] = useState<SalesPartnerBankAccountsModel[]>(bankAccountsList);
  const [open, setOpen] = useState(false);

  const handleAddBankAccount = (newAccount) => {
    setFilteredRows([...filteredRows, newAccount]);
  };

  useEffect(() => {
    setFilteredRows(bankAccountsList);
  }, [bankAccountsList]);

  const openAddDataGrid = () => setOpen(true);

  const handleSearchTextChange = (event: any) => {
    const text = event.target.value.toLowerCase();
    const filtered = searchRows(text, bankAccountsList);
    setFilteredRows(filtered);
  };

  const columns: GridColDef[] = [
    { field: 'id', headerName: '#', flex: 0.2, headerAlign: 'left' },
    { field: 'accountName', headerName: 'Account Name', flex: 1, headerAlign: 'left' },
    { field: 'accountNumber', headerName: 'Account Number', flex: 1, headerAlign: 'left' },
    { field: 'bankName', headerName: 'Bank Name', flex: 1, headerAlign: 'left' },
    { field: 'ifscCode', headerName: 'IFSC Code', flex: 1, headerAlign: 'left' },
    {
      field: 'accountTypeId',
      headerName: 'Account Type',
      flex: 1,
      headerAlign: 'left',
      renderCell: (param) => {
        const name = bankAccountTypes.find((item) => item.id === param.row.accountTypeId)?.name;
        return name;
      }
    },
    { field: 'isActive', headerName: 'Status', flex: 0, align: 'left', headerAlign: 'left', renderCell: renderStatusCell },
    {
      field: 'edit',
      headerName: '...',
      width: 18,
      sortable: false,
      renderCell: (params) => <SalesPartnerBankAccountOptions rowData={params.row} />
    }
  ];

  return (
    <>
      <SearchAppBar
        handleChange={handleSearchTextChange}
        addData={openAddDataGrid}
        buttonText="+ Add Bank Account"
      >
        <VemigoGrid rows={filteredRows} columns={columns} />
      </SearchAppBar>
      <AddSalesPartnerBankAccount open={open} handleClose={() => setOpen(false)} onAddBankAccount={handleAddBankAccount} />
    </>
  );
};

export default SalesPartnerBankAccountsList;
